export default __webpack_public_path__ + "static/media/Delivery.a8a9823d.svg";